import AndContainer from 'components/common/AndContainer';
import CaptionText from 'components/common/CaptionText';
import { Container } from 'components/credits/credit-details/RequiredCredentialsSection/components';
import { Fragment } from 'react';
import { RequiredCredential } from 'types/required-credential';
import { Strong } from 'components/common/Strong';
import { getHeadingAndSubHeading } from 'utils/required-credential';
import useFormSchema from 'hooks/use-form-schema';
import useTranslation from 'hooks/use-translation';
type Props = {
  requiredCredentials: RequiredCredential[];
};

export default function RequiredCredentialsSection(props: Props): JSX.Element | null {
  const { requiredCredentials } = props;
  const formSchema = useFormSchema();
  const translation = useTranslation();

  if (requiredCredentials.length === 0 || !formSchema || !translation) {
    return null;
  }

  return (
    <Container className='required-credentials-section'>
      <Strong>When you complete</Strong>
      {requiredCredentials.map((credential, index, array) => {
        const { heading, subHeading, unjoinedHeadings, unjoinedSubHeadings } = getHeadingAndSubHeading(
          credential,
          formSchema,
        );
        return (
          <Fragment key={`${heading}${subHeading}`}>
            <span className='required-credential-heading'>
              {unjoinedHeadings.map((heading) => (
                <span key={heading.propertyName} className={heading.propertyName}>
                  {heading.value + ' '}
                </span>
              ))}
            </span>
            <CaptionText className='required-credential-subheading'>
              {unjoinedSubHeadings.map((subheading) => (
                <span key={subheading.propertyName} className={subheading.propertyName}>
                  {subheading.value + ' '}
                </span>
              ))}
            </CaptionText>
            {index !== array.length - 1 && <AndContainer />}
          </Fragment>
        );
      })}
    </Container>
  );
}
